import { mainNavigation } from './navigation';
import { accessibility } from './accessibility';
import { helpers } from './helpers';
import { stickyHeader } from './sticky-header';

mainNavigation();
accessibility();
helpers();
stickyHeader();